import { render, staticRenderFns } from "./BaseIconButtonDelete.vue?vue&type=template&id=aada6ef2&"
import script from "./BaseIconButtonDelete.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports